import cookieUniversal from 'cookie-universal';
export default (function (_ref, inject) {
  var req = _ref.req,
    res = _ref.res;
  var options = {
    "alias": "cookies",
    "parseJSON": true
  };
  inject(options.alias, cookieUniversal(req, res, options.parseJSON));
});